<template>
  <div class="form-group">
    <label class="form-label">Событие*</label>
    <CustomSelect name="event" @initialize="onEventSelectInitialize" @itemSelected="onEventSelectItemSelected">
      <option v-if="tempDisability" data-component="SimpleTextarea" value="TemporaryDisability">Временная нетрудоспособность в результате несчастного случая или болезни»</option>
      <option data-component="SimpleTextarea" value="LeavingLife">Уход из жизни в результате несчастного случая</option>
      <option data-component="SimpleTextarea" value="FirstDisabilityGroup">Установление инвалидности I группы</option>
      <option data-component="SimpleTextarea" value="SecondDisabilityGroup">Установление инвалидности II группы</option>
      <option data-component="RequiredTextarea" value="Injury">Травма</option>
    </CustomSelect>
  </div>

  <component :is="personalProtectionComponent"></component>

  <ContractInfoInsurer/>
</template>

<script>
import ContractInfoInsurer from "@/components/insurances/shared/ContractInfoInsurer";
import * as mns from "@/store/mutation-types";
import {mapGetters} from "vuex";
import RequiredTextarea from "@/components/insurances/PersonalProtection/childs/RequiredTextarea";
import SimpleTextarea from "@/components/insurances/PersonalProtection/childs/SimpleTextarea";
import CustomSelect from "@/components/utils/CustomSelect";

export default {
  anotherNameLife: "PersonalProtection",
  components: {CustomSelect, ContractInfoInsurer, SimpleTextarea, RequiredTextarea},
  props: {
    tempDisability: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onEventSelectInitialize(event){
      this.$store.commit(mns.SET_EVENT, event.getValue().value);
      this.$store.commit(mns.SET_PERSONAL_PROTECTION_COMPONENT, event.getValue().customProperties.component);
    },
    onEventSelectItemSelected(event){
      this.$store.commit(mns.SET_EVENT, event.detail.choice.value);
      this.$store.commit(mns.SET_PERSONAL_PROTECTION_COMPONENT, event.detail.choice.customProperties.component);
    },
  },
  computed: {
    ...mapGetters(['personalProtectionComponent',])
  }
}
</script>

<style scoped>

</style>